module.exports = __webpack_public_path__ + "img/video3.43fc4f02.png";